<template>
  <div class="LkMunMehReviewForm">
    <Header
      v-model="currentTab"
      :loading="isLoadingForm"
      :slug="slug"
      :topic-slug="topicSlug"
    />

    <v-skeleton-loader
      :loading="isLoadingForm"
      type="article, actions"
      :types="{ actions: 'button@4' }"
      :style="isLoadingForm ? 'padding-top: 16px;' : ''"
    >
      <v-tabs-items v-model="currentTab" class="LkMunMehReviewForm__tab-items">
        <v-tab-item
          v-for="(item, index) in content"
          :key="index"
          :value="index"
          :transition="false"
        >
          <component
            :is="item.component"
            :ref="item.ref"
            v-bind="item.attrs || $attrs"
            v-on="item.listeners || $listeners"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-skeleton-loader>
  </div>
</template>

<script>
import Header from '@/views/LKMunMeh/HostView/components/LKMunMehHostViewHeader.vue'

const FormContent = () => import(
  /* webpackChunkName: "LKMunMehHostViewFormContent" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewFormContent.vue'
)

const FormExcel = () => import(
  /* webpackChunkName: "LKMunMehHostViewFormExcel" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewFormExcel.vue'
)

const FormLogs = () => import(
  /* webpackChunkName: "LKMunMehHostViewFormLogs" */
  '@/views/LKMunMeh/HostView/components/LKMunMehHostViewFormLogs.vue'
)

import { LKMunMehHostViewMapper as StoreMapper } from '../store'

export default {
  name: 'LKMunMehHostViewForm',
  components: {
    Header,
  },
  props: {
    formId: {
      type: Number,
      required: true,
    },
    slug: String,
    topicSlug: String,
  },
  data() {
    return {
      isLoadingForm: false,
      form: null,
      currentTab: 1,
    }
  },
  computed: {
    content() {
      return [
        {
          component: FormExcel,
        },
        {
          ref: 'FormContent',
          attrs: {
            ...this.$attrs,
            form: this.form,
          },
          component: FormContent,
        },
        {
          component: FormLogs,
          attrs: {
            ...this.$attrs,
            form: this.form,
          },
          listeners: {
            'action:view': this.onJumpToIndicator,
          },
        },
      ]
    },
  },
  watch: {
    formId: {
      async handler(v) {
        if (!v) return
        await this.onGetForm(v)
      },
      immediate: true,
    },
  },
  methods: {
    ...StoreMapper.mapActions([
      'getForm',
      'getFormMarks',
      'getFormLoggedIndicators',
    ]),
    onJumpToIndicator(v) {
      const { indicator_id } = v
      if (indicator_id) {
        const formContent = this.$refs.FormContent[0]
        const url = formContent?.getIndicatorUrlById(indicator_id)
        if (url) {
          this.currentTab = 1
          formContent?.goToIndicatorByUrl(url)
        }
      }
    },
    async onGetForm(id) {
      this.isLoadingForm = true

      try {
        this.form = await this.getForm(id)

        const { munMehId, formId } = this.$route.params
        await this.getFormMarks({ munMehId, formId })
        await this.getFormLoggedIndicators(formId)
      } catch (e) {
        this.$notice.errors(e)
      }

      this.isLoadingForm = false
    },
  },
}
</script>

<style lang="scss">
.LkMunMehReviewForm {
  @import "~@/views/LKMunMeh/styles/_MunMehFormStylesheet.scss";
}
</style>
